import Vue from 'vue'
// import store from '../store/index'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Logout from '../views/Logout.vue'
import RecoverPass from '../views/RecoverPass.vue'
import FactoringDashboard from '../views/Products/FactoringDashboard.vue'
import Profile from '../views/Profile.vue'
import PaymentReferences from '../views/PaymentReferences.vue'
import InvoicesHistory from '../views/InvoicesHistory.vue' // InterestInvoices
import Invoices from '../views/Invoices.vue' // Paid Invoices
import InterestHistory from '../views/InterestHistory.vue' // Intereses Devengados
import AdminUsers from '../views/AdminUsers.vue'
import Portafolio from '../views/Portafolio.vue'
import AmortizableDetail from '../views/Products/AmortizableDetail.vue'
import RevolvingDetail from '../views/Products/RevolvingDetail.vue'
import InvoicesReport from '../views/Reports/InvoicesReport.vue'
import UnderConstruction from '../views/Products/UnderConstruction.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => {
    if (err && err.name !== 'NavigationDuplicated') throw err
  })
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout
  },
  {
    path: '/recoverPass',
    name: 'recoverPass',
    component: RecoverPass
  },
  {
    path: '/detail/factoring',
    name: 'factoringDetail',
    component: FactoringDashboard
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile
  },
  {
    path: '/paymentReferences',
    name: 'paymentReferences',
    component: PaymentReferences
  },
  {
    path: '/invoicesHistory',
    name: 'invoicesHistory',
    component: InvoicesHistory
  },
  {
    path: '/invoices',
    name: 'invoices',
    component: Invoices
  },
  // {
  //   path: '/costCenters',
  //   name: 'costCenters',
  //   component: CostCenters
  // },
  {
    path: '/interestHistory',
    name: 'interestHistory',
    component: InterestHistory
  },
  {
    path: '/admin/users',
    name: 'adminUsers',
    component: AdminUsers
  },
  {
    path: '/',
    name: 'portafolio',
    component: Portafolio
  },
  {
    path: '/detail/credit',
    name: 'amortizableDetail',
    component: AmortizableDetail
  },
  {
    path: '/detail/revolving',
    name: 'revolvingDetail',
    component: RevolvingDetail
  },
  {
    path: '/detail/under-construction',
    name: 'underConstruction',
    component: UnderConstruction
  },
  {
    path: '/reports/invoices',
    name: 'invoicesReport',
    component: InvoicesReport
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASEPATH,
  routes: routes
})

export default router
